import { wp, hp } from '../../utils/responsive';

export const MAXIMIZED_LABEL_FONT_SIZE = hp(1.9);
export const MINIMIZED_LABEL_FONT_SIZE = hp(1.8);
export const LABEL_WIGGLE_X_OFFSET = wp(1);
export const LABEL_PADDING_HORIZONTAL = wp(2);
